import { ProjectFiltersPanel } from '@features/projects/ProjectFiltersPanel';
import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import SearchField from '@ui/SearchField';
import { SxProps, TextFieldProps } from '@mui/material';
import { useProjectSearchString } from '@client/hooks/use-filter-projects.hooks';

const SearchProjects: React.FC = () => {
  const [searchString, setSearchString] = useProjectSearchString();
  const [searchParams, setSearchParams] = useSearchParams();
  const hasFilters = ['p-labels', 'p-programs', 'p-owner'].some((key) =>
    Boolean(searchParams.get(key)),
  );
  const clearSearchAndFilters = useCallback(() => {
    setSearchParams(
      (params) => {
        for (const key of ['p-search', 'p-labels', 'p-programs', 'p-owner'])
          params.delete(key);
        return params;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return (
    <>
      <SearchField
        id="project-list-search"
        autoFocus
        placeholder="Search projects"
        sx={sx}
        slotProps={slotProps}
        iconSize={18}
        trailingAction={<ProjectFiltersPanel />}
        value={searchString}
        showClear={hasFilters}
        onClear={clearSearchAndFilters}
        clearTooltip="Clear filters"
        onChange={setSearchString}
      />
    </>
  );
};

const sx: SxProps = { flex: 1 } as const;

const slotProps: TextFieldProps['slotProps'] = {
  input: {
    sx: {
      padding: '0 4px 0 4px',
      fontSize: 13,
      '& > .MuiBox-root:first-of-type': { px: '4px' },
      height:
        'clamp(32px, calc(32px + (var(--project-list-app-header-height, 240px) - 48px) / 12), 48px)',
      '--search-background-expansion':
        'clamp(0, calc((var(--project-list-app-header-height, 240px) - 48px) / 192px), 1)',
      backgroundColor:
        'color-mix(in srgb, rgba(216,216,205,0.4) calc(var(--search-background-expansion) * 100%), rgba(0,0,0,0.05))',
      border:
        '1px solid rgba(0,0,0,calc(var(--search-background-expansion) * 0.1))',
      borderRadius: '6px',
    },
  },
  htmlInput: { sx: { padding: '2px 0px', fontSize: 13 } },
} as const;

export default SearchProjects;
